module.exports = __webpack_public_path__ + "static/media/new1.79e08694.png";